import { inject, bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
//import { AuthService } from '../../services/authService';
//import {UserMessageService} from '../../services/userMessageService';

//@inject(AuthService, Router, UserMessageService)
@inject(Router)

export class TPErrorMessage {
   
    constructor(router) {
        this.router = router;
        this.forbidden = false; //full forbidden access & seat
        this.forbidden_seat = false; // access is allowed but no seat
    }

    activate(model) {
        if(model.error == 100){
            console.log('error 100');
            this.forbidden = true;
            this.forbidden_seat = false;
            this.vendasta_plus_user_access = false;
        } else if(model.error == 102){
            console.log('Vendasta User');
            this.forbidden = false;
            this.forbidden = false;
            this.vendasta_plus_user_access = true;
        } else if(model.error == 101){
            console.log('other error');
            this.forbidden = false;
            this.forbidden_seat = true;
            this.vendasta_plus_user_access = false;
        } else {
            this.forbidden = false;
            this.forbidden = false;
            this.vendasta_plus_user_access = false;
        }
        
    }
    attached(){
        console.log('nav length ' + $('.navbar-nav').length + $('#footer').length);
       $('.navbar-nav').hide();
       //$('.content').hide();
       //$('.nav').hide();
       $('#footer.au-target').hide();
    }

  
}
